module.exports = __webpack_public_path__ + "static/img/sdab_zxtj_one.46483d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sdab_zxtj_one.png
// module id = 1XRg
// module chunks = 21